import React from 'react';
import LoadingOverlay from 'react-loading-overlay';
import './Progress.css';
import { Button } from 'reactstrap';
import API from '../lib/API';
import utils from '../lib/Utils';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faArrowCircleRight, faCheckCircle, faTimes} from "@fortawesome/free-solid-svg-icons";
import SplitBar from './SplitBar';
import Album from './Album';
import firebase from '../lib/Firebase';
import UserData from '../lib/UserData';
import ToolsRequestFormDialog from './ToolsRequestFormDialog';
import config from '../config';
import { XMLParser } from 'fast-xml-parser';
import AlertDialog from './AlertDialog';
import DigitalCatalogDialog from './DigitalCatalogDialog';

const bunruis = {
  0:'すべて',
  1:'卒前',
  2:'卒後',
  3:'記念誌'
}

class Progress extends React.Component {
  

  originalAlbums = [];
  filters = {}

  constructor(props){  
    super(props);

    let auth = firebase.auth();
    this.state = {
      username: auth.currentUser.displayName,
      email: auth.currentUser.email,
      
      loading: true,
      edaban: utils.getEdaban(),
      bunrui: utils.getBunrui(),
  
      customers: [],
      customerInfo: null,
      albums: [],
      hotaiNyukoPer: 0,
      hontaiKoryoPer: 0,
      selectedAlbum: null,
      
      sortType: "hinmei",
      sortDirection: "asc",
  
      filterHinmei: '',
      filterCover: '',
      filterInPagePer: '',
      filterProofPer: '',
      filterBunsyu: '',
      filterDelivery: '',
  
      showPDFAuthority: {
        hasAny:false,
        onProofing: false,
        onFinProof: false,
      },
      orderConfirm: false,
      loginFileStation: false,
  
      showToolsRequestDialog: '',
      showLogoutDialog: false,
      showDigitalCatalogDialog: '',
      digitalCatalogs: [],
      digitalCatalogTitle: '',
  
      cautions:[],
      hideCautionIds: [],
      noteRssUpdated: null,

      alert: null,

      customerTantos: ['担当者'],
    } 
  }

  loadCautions = () => {
    API.loadCautions().then(cautions => {
      let hideCautionIds = (()=>{
        if (!window.localStorage) return [];
        let o = localStorage.getItem('hideCautions');
        if (!o) return [];
        let lim = new Date();
        lim.setDate(lim.getDate()-1);
        lim = lim.toLocaleDateString('sv-SE');
        return JSON.parse(o).filter(i=>{
          return i.date > lim;
        }).map(i=>i.id)
      })();
      hideCautionIds = hideCautionIds.concat(this.state.hideCautionIds).reduce((carry, id)=>{
        if (carry.indexOf(id) < 0) carry.push(id);
        return carry;
      }, []);

      if (!window.location.href.startsWith('https://portal.appx.co.jp/') && (new Date()).toLocaleString('sv-SE') >= '2026-10-13 09:00') {
        cautions.push({
          id:0,
          mode:2,
          title:'アルバムサポートURL変更のお知らせ',
          message:'この度の社名変更に伴い、アルバムサポートのURLも変更いたします。今後は <a href="https://portal.appx.co.jp" style="color:blue;">portal.appx.co.jp</a> よりアルバムサポートをご利用ください。お手数をおかけいたしますが、ブックマークの変更もお願いいたします。<br/>また、現在のURL（as.adachi-printing.co.jp）は今月末をもって使用できなくなりますので、ご了承ください。'
        });
      }

      this.setState({ 
        cautions: cautions,
        hideCautionIds: hideCautionIds
      });
    });
  }

  componentDidMount = () => {
    UserData.getUserAttributes()
      .then(userAttributes => {
        let state = {
          orderConfirm: userAttributes.orderConfirm,
          showPDFAuthority: userAttributes.showPDFAuthority,
          loginFileStation: userAttributes.loginFileStation,
        };

        this.setState(state);
      });

    setInterval(()=>{
      this.loadCautions();
    }, config.cautionLoadInterval);
    this.loadCautions();
    
    API.getCustomers().then(customers=>{
      this.setState({customers: customers});

      if (customers.length === 0) {
        this.setState({
          loading: false,
          alert: {
            okButtonOnly: true,
            okButtonName: 'ログアウト',
            onClickOKButton: this.doLogout,
            contents: (<div style={{padding:'2em 1em'}}>顧客情報が設定されていません。サーバー管理者にご連絡ください。</div>)
          }
        });
        return;
      }
      this.customerSel.value = customers[0].code;

      if (this.props.searches.hasOwnProperty('code')) {
        API.getSearchPropsFromCode(this.props.searches.code).then(data=>{
          if (data) {
            let findCustomer = customers.find(s=>s.code===data.customer_code);
            if (findCustomer) this.customerSel.value = findCustomer.code;
            let findEdaban = Array.prototype.find.call(this.edabanSel.querySelectorAll('option'), o=>o.value===data.edaban);
            if (findEdaban) this.edabanSel.value = findEdaban.value;
            let findBunrui = Array.prototype.find.call(this.bunruiSel.querySelectorAll('option'), o=>o.value===data.bunrui.toString());
            if (findBunrui) this.bunruiSel.value = findBunrui.value;
            this.doSearch(this.customerSel.value, this.edabanSel.value, this.bunruiSel.value, this.props.searches.code);
          }
          else {
            this.setState({
              alert: {
                okButtonOnly: true,
                contents: (<div>アルバム（{this.props.searches.code}）へのアクセス権がありません。</div>)
              }
            });
            this.doSearch(this.customerSel.value, this.edabanSel.value, this.bunruiSel.value, null);
          }
        });
        return;
      }

      let searchProps = utils.loadSearchProps();
      let customerCode = this.props.searches.hasOwnProperty('customer') ? this.props.searches.customer : (searchProps ? searchProps.c : null);
      if (customerCode) {
        let findCustomer = customers.find(s=>s.code===customerCode);
        if (findCustomer) this.customerSel.value = findCustomer.code;
      }
      let edaban = this.props.searches.hasOwnProperty('edaban') ? this.props.searches.edaban : (searchProps ? searchProps.e : null);
      if (edaban) {
        let findEdaban = Array.prototype.find.call(this.edabanSel.querySelectorAll('option'), o=>o.value===edaban);
        if (findEdaban) this.edabanSel.value = findEdaban.value;
      }
      let bunrui = this.props.searches.hasOwnProperty('bunrui') ? this.props.searches.bunrui : (searchProps ? searchProps.b : null);
      if (bunrui) {
        let findBunrui = Array.prototype.find.call(this.bunruiSel.querySelectorAll('option'), o=>o.value===bunrui);
        if (findBunrui) this.bunruiSel.value = findBunrui.value;
      }

      this.doSearch(this.customerSel.value, this.edabanSel.value, this.bunruiSel.value, null);
    });

    // TOPICS RSSの読み込み
    API.getTopicsRSS().then(rssString=>{
      try {
        let parser = new XMLParser({
          ignoreAttributes: false
        });
        let jsonObj = parser.parse(rssString);
        if (!jsonObj || !jsonObj.rss || jsonObj.rss.channel.item.length === 0) return;
        let before7day = new Date();
        before7day.setDate(before7day.getDate() - 7);
        let pubDate = new Date(jsonObj.rss.channel.item[0].pubDate);
        let pubDateText = (pubDate.getMonth()+1)+'/'+pubDate.getDate();
        this.setState({
          noteRssUpdated: pubDate > before7day ? pubDateText : null
        });
      }
      catch (e) {
        console.log(e);
      }
    });

    // デジタルカタログ一覧の読み込み
    API.listDigitalCatalog().then(catalogs=>{
      this.setState({
        digitalCatalogs: catalogs || [],

      });
    })

  } // end of componentDidMount

  componentDidUpdate = () => {
    // update Progress-Body height
    let cautionsHeight = this.ProgressCautions ? this.ProgressCautions.getBoundingClientRect().height : 0;
    this.ProgressBody.style.height = 'calc(100% - ' + (cautionsHeight + 82) + 'px)';
  }

  handleUpdateTopicsBtn = () => {
    window.open(config.updateTopicsURL, '_blank', 'noopener noreferrer');
  }
  handleLogoutBtn = () => {
    this.setState({showLogoutDialog: true});
  }
  cancelLogout = e => {
    e.preventDefault();
    this.setState({showLogoutDialog: false});
  }
  doLogout = e => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    firebase.auth().signOut();
    UserData.clearStore();
  }
  renderLogoutDialog = () => {
    return (<div className="dialog LogoutDialog">
      <div className="dialog-window">
        <div className="dialog-message">アルバムサポートからログアウトしますか？</div>
        <div className="dialog-buttons">
          <button className="dialog-button cancelBtn" onClick={this.cancelLogout}>キャンセル</button>
          <button className="dialog-button logoutBtn" onClick={this.doLogout}>ログアウト</button>
        </div>
      </div>
    </div>);
  }
  
  handleChangeSearch = () => {
    this.setState({loading:true});
    this.originalAlbums = [];
    this.doSearch(this.customerSel.value, this.edabanSel.value, this.bunruiSel.value);
  }

  doSearch = (customerCode, edaban, bunrui, code) => {
    this.splitBar.close();
    utils.storeSearchProps({c:customerCode, e:edaban, b:bunrui});

    API.getCustomerInfo(customerCode).then(info => {
      this.setState({customerInfo:info});

      API.listAlbums(customerCode, edaban, bunrui).then(albums => {
        let calcedAlbums = albums.map(album => {
          album.inPagePer = Math.round(album.hontaiNyukoCount / album.hontaiCount * 100) + '%';
          album.proofPer  = Math.round(album.hontaiProofCount / album.hontaiCount * 100) + '%';
          return album;
        });
        this.originalAlbums = calcedAlbums;
        this.filters = {}

        let newState = {
          loading: false,
          selectedAlbum: null,
          albums: calcedAlbums,
          hontaiNyukoPer: Math.floor(calcedAlbums.reduce((carry, album)=>{return carry+album.hontaiNyukoCount}, 0) / calcedAlbums.reduce((carry, album)=>{return carry+album.hontaiCount}, 0) * 100),
          hontaiKoryoPer: Math.floor(calcedAlbums.reduce((carry, album)=>{return carry+album.hontaiProofCount}, 0) / calcedAlbums.reduce((carry, album)=>{return carry+album.hontaiCount}, 0) * 100),
          filterHinmei: '',
          filterCover: '',
          filterInPagePer: '',
          filterProofPer: '',
          filterBunsyu: '',
          filterDelivery: '',
          customerTantos: albums.reduce((carry, alb) => {
            if (alb.customer_tanto && carry.indexOf(alb.customer_tanto) < 0) carry.push(alb.customer_tanto);
            return carry;
          }, ['担当者']),
        }

        if (code && albums.find(a=>a.code === code)) {
          newState.selectedAlbum = code;
        }

        this.customerTantoSel.selectedIndex = 0;
        this.setState(newState);
        this.doSort();
      });

    });
  }

  handleClickAlbum = (e) => {
    let tr = e.target.closest('tr');
    if (tr) this.setState({selectedAlbum: tr.dataset.code});
  }

  handleUpdateConfirmStatus = (albumCode, status) => {
    let albums = this.state.albums.map(o => {
      if (o.code === albumCode) o.orderConfirm = status;
      return o;
    })
    this.setState({albums:albums});
  }
 
  // filter
  handleChangeFilter = () => {
    if (this.customerTantoSel.selectedIndex === 0) {
      Array.prototype.forEach.call(this.ProgressTbody.querySelectorAll('tr'), tr => {
        tr.style.display = null;
      });
    }
    else {
      let t = this.customerTantoSel[this.customerTantoSel.selectedIndex].textContent;
      Array.prototype.forEach.call(this.ProgressTbody.querySelectorAll('tr'), tr => {
        tr.style.display = tr.querySelector('td.customer_tanto').textContent === t ? null : 'none';
      });
    }
  }

  // sort
  handleClickSortHeader = (e) => {
    if (e.target.classList.contains('Progress-List-Sort-DirectionBtn')) {
      this.setState({sortDirection: e.target.dataset.direction}, () => {
        this.doSort();
      });
    }
    else if (e.target.classList.contains('Progress-List-Sort-TypeBtn')) {
      if (this.state.sortType === e.target.dataset.type) {
        this.setState({sortDirection: (this.state.sortDirection === 'asc' ? 'desc' : 'asc')}, () => {
          this.doSort();
        });
        return;
      }
      this.setState({sortType: e.target.dataset.type}, () => {
        this.doSort();
      });
    }
  }
  handleChangeSortSelect = (e) => {
    this.setState({sortType: e.target.value}, () => {
      this.doSort();
    });
  }
  doSort = () => {
    let direction = this.state.sortDirection === 'desc' ? 1 : -1;
    let albums = this.state.albums;
    switch (this.state.sortType) {
      case 'hinmei':
        albums.sort( (a1, a2) => {
          return a1.hinmei <= a2.hinmei ? direction : -direction;
        });
        break;
      case 'coverStatus':
      case 'hontaiStatus':
      case 'bunsyuStatus':
        let statuses = ['koryo', 'nyuko', 'minyuko', 'none'];
        albums.sort((a1, a2) => {
          return parseFloat(statuses.indexOf(a1[this.state.sortType])) <= statuses.indexOf(a2[this.state.sortType]) ? direction : -direction;
        });
        break;
      case 'delivery':
        albums.sort((a1, a2) => {
          return parseFloat(parseFloat(a1[this.state.sortType])) <= parseFloat(a2[this.state.sortType]) ? direction : -direction;
        });
        break;
      default:
    }
    this.setState({albums:albums});
  }

  handleClose = () => {
    this.splitBar.close();
  }
  splitBarOnClose = () => {
    this.setState({selectedAlbum:null});
  }

  handleClickButtonBar = async (e) => {
    e.preventDefault();
    if (e.target.classList.contains('Progress-ToolsRequestButton')) {
      this.setState({ showToolsRequestDialog: 'list'});
    }
    if (e.target.classList.contains('Progress-DigitalCatalogButton')) {
      this.setState({ showDigitalCatalogDialog: 'choose'});
    }
    if (e.target.classList.contains('Progress-GoogleDriveButton')) {
      let w = window.open('', 'Google Drive');
      w.location.href = this.state.customerInfo.googleDriveUrl;
    }
    else {
      let pathBase = (()=>{
        if (e.target.classList.contains('Progress-DataUploadButton')) return '/#userid#/up';
        if (e.target.classList.contains('Progress-DataDownloadButton')) return '/#userid#/down';
        if (e.target.classList.contains('Progress-DistributesButton')) return '/Public';
        return null;
      })();
      if (!pathBase) return;
      let w = window.open('', 'filestation');
      let ret = await API.getSidForLoginToFileServer(this.customerSel.value);
      if (!ret) {
        w.close();
        return;
      }
      w.location.href = 'https://file.adachi-printing.co.jp/filestation?path='+pathBase.replace('#userid#',ret.userid)+'&sid='+ret.sid;
    }
  }
  renderToolsRequestDialog = () => {
    if (this.state.showToolsRequestDialog === 'list')
    return (<div className="dialog ToolsRequestDialog">
      <div className="dialog-window ToolsRequestDailog-window">
        <div className="dialog-message">Album Tools 申し込み</div>
        <div className="dialog-main" onClick={this.handleClickToolsRequestBtn}>
          <div className="ToolsRequestItem ToolsRequestItem-assist">
            <span className="message">無料で使えるアルバム編集システム</span>
            <button className="button" data-name="assist_v2"><FontAwesomeIcon icon={faArrowCircleRight}></FontAwesomeIcon>アシストの申し込み</button>
          </div>
          <div className="ToolsRequestItem ToolsRequestItem-kaolabo">
            <span className="message">顔認証システムで写真セレクトを支援</span>
            <button className="button" data-name="kaolaboAlbum"><FontAwesomeIcon icon={faArrowCircleRight}></FontAwesomeIcon>かおラボの申し込み</button>
          </div>
          <div className="ToolsRequestItem ToolsRequestItem-qr">
            <span className="message">QRでアルバム動画サービス</span>
            <button className="button" data-name="qrRequest_v2"><FontAwesomeIcon icon={faArrowCircleRight}></FontAwesomeIcon>QR動画の申し込み</button>
          </div>
          <div className="ToolsRequestItem ToolsRequestItem-ar">
            <span className="message">ARでアルバム動画サービス</span>
            <button className="button" data-name="arRequest"><FontAwesomeIcon icon={faArrowCircleRight}></FontAwesomeIcon>AR動画の申し込み</button>
          </div>
          <div className="ToolsRequestItem ToolsRequestItem-photoAssist">
            <span className="message">プリント販売サービス</span>
            <button className="button" data-name="photoAssist"><FontAwesomeIcon icon={faArrowCircleRight}></FontAwesomeIcon>フォトアシストの申し込み</button>
          </div>
        </div>
        <div className="dialog-buttons">
          <button className="dialog-button ToolsRequest-CancelBtn" onClick={this.handleClickToolsRequestDailogCancelBtn}>キャンセル</button>
        </div>
      </div>
    </div>);
    else if (this.state.showToolsRequestDialog !== '') {
      let data = {
        username: this.state.username,
        email: this.state.email,
        school: this.state.selectedAlbum,
        albums: this.state.albums,
        customer: this.customerSel.value,
        customerName: this.customerSel[this.customerSel.selectedIndex].innerText
      };
      return <ToolsRequestFormDialog type={this.state.showToolsRequestDialog} data={data} close={this.handleClickToolsRequestCancelBtn} reloadAlbum={this.handleReloadAlbum}></ToolsRequestFormDialog>;
    }
    else {
      return null;
    }
  }
  handleClickDigitalCatalogChooseDialog = e => {
    if (e.target.classList.contains('closeBtn')) {
      this.setState({showDigitalCatalogDialog:''});
    }
    else if (e.target.classList.contains('DigitalCatalogChooseDialog-catalog')) {
      this.setState({showDigitalCatalogDialog:e.target.dataset.id, digitalCatalogTitle:e.target.querySelector('.name').innerText});
    }
    else if (e.target.classList.contains('closeBtn')) {
      this.setState({showDigitalCatalogDialog:''});
    }
  }
  renderDigitalCatalogDialog = () => {
    if (this.state.showDigitalCatalogDialog === '') return null;
    if (this.state.showDigitalCatalogDialog === 'choose') {
      return (<div className="dialog DigitalCatalogChooseDialog">
        <div className="dialog-window DigitalCatalogChooseDialog-window" onClick={this.handleClickDigitalCatalogChooseDialog}>
          <div className="DigitalCatalogChooseDialog-header">
            <button className="closeBtn" onClick={this.props.handleClose}><FontAwesomeIcon icon={faTimes}></FontAwesomeIcon></button>
            <span className="title">デジタルカタログ</span>
          </div>
          <LoadingOverlay active={this.state.digitalCatalogs.length === 0} spinner text="読み込み中" className="DigitalCatalogChooseDialog-loading">
            <div className="DigitalCatalogChooseDialog-catalogs">
              {
                this.state.digitalCatalogs.map(c=>{
                  return (<div key={c.id} className="DigitalCatalogChooseDialog-catalog" data-id={c.id}>
                    <img className="icon" src={c.icon} alt={c.name}/>
                    <div className="name">{c.name}</div>
                  </div>);
                })
              }
            </div>
          </LoadingOverlay>
        </div>
      </div>
      )
    }
    return (<DigitalCatalogDialog catalogId={this.state.showDigitalCatalogDialog} catalogName={this.state.digitalCatalogTitle} handleClose={this.handleClickDigitalCatalogChooseDialog}></DigitalCatalogDialog>);
  }
  handleClickToolsRequestDailogCancelBtn = e => {
    this.setState({showToolsRequestDialog:''});
  }
  handleClickToolsRequestBtn = e => {
    e.preventDefault();
    if (e.target.classList.contains('button')) {
      this.setState({showToolsRequestDialog:e.target.dataset.name});
    }
  }
  handleClickToolsRequestCancelBtn = e => {
    this.setState({showToolsRequestDialog:''});
  }
  handleReloadAlbum = (albumCode) => {
    if (albumCode === this.state.selectedAlbum) {
      this.ProgressAlbum.loadAlbum();
    }
  }

  getStatusText = status => {
    switch (status) {
      case 'koryo': return '校了';
      case 'nyuko': return '完了';
      case 'minyuko': return '未入稿';
      case 'send': return '発送済';
      case 'yet': return '未発送';
      default: return '';
    }
  }

  closeAlert = () =>{
    this.setState({alert:null});
  }
  handleCloseProgressCaution = e => {
    e.preventDefault();
    let id = parseInt(e.target.closest('.Progress-Caution').dataset.id, 10);
    if (window.localStorage) {
      let hideCautions = (()=>{
        let o = localStorage.getItem('hideCautions');
        if (!o) return [];
        let lim = new Date();
        lim.setDate(lim.getDate()-1);
        lim = lim.toLocaleDateString('sv-SE');
        return JSON.parse(o).filter(i=>{
          return i.date > lim;
        }).map(i=>i.id);
      })();

      if (id > 0 && !hideCautions.find(c=>c.id===id)) {
        hideCautions.push({
          id: id,
          date: (new Date()).toLocaleDateString('sv-SE')
        });
        localStorage.setItem('hideCautions', JSON.stringify(hideCautions));
      }
    }

    let hideCautionIds = this.state.hideCautionIds;
    hideCautionIds.push(id);
    this.setState({hideCautionIds: hideCautionIds});
  }

  render() {
    return (
      <LoadingOverlay active={this.state.loading} spinner text={"読み込み中"} styles={{wrapper:{width:'100vw',height:'100vh'}}}>
        <div className="container Progress">

          {
            this.state.cautions && this.state.cautions.length > 0
            ? <div className="Progress-Cautions" ref={ref=>{this.ProgressCautions = ref}}>
              {
                this.state.cautions.filter(c=>{
                  return this.state.hideCautionIds.indexOf(c.id) < 0;
                }).map((c, i) => {
                  return <div className="Progress-Caution" key="{i}" data-id={c.id} data-mode={c.mode||3}>
                    <button className="closeBtn" onClick={this.handleCloseProgressCaution}><FontAwesomeIcon icon={faTimes}></FontAwesomeIcon></button>
                    <div className="Progress-CautionTitle">{c.title}</div>
                    <div className="Progress-CautionMessage" dangerouslySetInnerHTML={{ __html: c.message}}></div>
                  </div>
                })
              }
            </div>
            : null
          }
          
          <div className="Progress-Header">
            <div className="Select">
              <select onChange={this.handleChangeSearch} ref={ref=>{this.customerSel = ref}}
                style={this.state.customers.length <= 1 ?{display:'none'}:{}}
              >{
                this.state.customers.map(c => {
                  return (<option key={c.code} value={c.code}>{c.name}</option>)
                })
              }</select>
            </div>
            <div className="Select">
              <select defaultValue={this.state.edaban} ref={ref=>{this.edabanSel = ref}} onChange={this.handleChangeSearch}
                style={this.state.customers.length <= 1 ?{maxWidth:'calc(100vw - 25px)'}:{}}>{
                  [this.state.edaban+1, this.state.edaban, this.state.edaban-1].map(edaban => {
                  return (<option key={edaban} value={edaban}>{edaban+1988 + '年度'}</option>)
                })
              }</select>
            </div>
            <div className="Select">
              <select defaultValue={this.state.bunrui} ref={ref=>{this.bunruiSel = ref}} onChange={this.handleChangeSearch}
                style={this.state.customers.length <= 1 ?{maxWidth:'calc(100vw - 40px)'}:{}}>{
                Object.keys(bunruis).map(k => {
                  return (<option key={k} value={k}>{bunruis[k]}</option>)
                })
              }</select>
            </div>
            <div className="Select">
              <select ref={ref=>{this.customerTantoSel = ref}} onChange={this.handleChangeFilter}
                style={this.state.customers.length <= 1 ?{maxWidth:'calc(100vw - 40px)'}:{}}>{
                Object.keys(this.state.customerTantos).map(k => {
                  return (<option key={k} value={k}>{this.state.customerTantos[k]}</option>)
                })
              }</select>
            </div>

            <div className="Progress-Header-Right">
              <a className="Progress-SNSBtn instagram" href="https://www.instagram.com/appx_jp/" target="_blank" rel="noopener noreferrer" title="アペックス株式会社
 - Instagram">アペックス株式会社 - Instagram</a>
              <a className="Progress-SNSBtn x-twitter" href="https://x.com/APPX_JP" target="_blank" rel="noopener noreferrer" title="アペックス株式会社
 - X">アペックス株式会社 - X</a>
              <Button className="Progress-UpdateTopicsBtn" onClick={this.handleUpdateTopicsBtn} data-updated={this.state.noteRssUpdated} title="アペックス株式会社 - NEWS & TOPICS">
              {
                this.state.noteRssUpdated
                ? <div className="Progress-TopicsUpdated">{this.state.noteRssUpdated} TOPICS更新しました！</div>
                : null
              }
              </Button>
              <Button className="Progress-LogoutBtn" onClick={this.handleLogoutBtn}><FontAwesomeIcon icon={faSignOutAlt} />ログアウト</Button>
            </div>
          </div>

          <div className="Progress-ButtonBar" onClick={this.handleClickButtonBar}>
              {this.state.albums.length <= 0 ? null
                : <button className="Progress-Button Progress-ToolsRequestButton">Album Tools 申し込み</button>}
              {!this.state.customerInfo || !this.state.customerInfo.fileServerAccount || !this.state.loginFileStation ? null
                : <button className="Progress-Button Progress-DataUploadButton" title="File Stationを開きます">データ アップロード</button>}
              {!this.state.customerInfo || !this.state.customerInfo.fileServerAccount || !this.state.loginFileStation ? null
                : <button className="Progress-Button Progress-DataDownloadButton" title="File Stationを開きます">データ ダウンロード</button>}
              {!this.state.customerInfo || !this.state.customerInfo.fileServerAccount || !this.state.loginFileStation ? null
                :<button className="Progress-Button Progress-DistributesButton" title="File Stationを開きます">素材 ダウンロード</button>}
              {!this.state.customerInfo || !this.state.customerInfo.googleDriveUrl ? null
                : <button className="Progress-Button Progress-GoogleDriveButton" title="Google Driveを開きます">データ送受信</button>}
              {this.state.digitalCatalogs.length === 0 ? null
                :<button className="Progress-Button Progress-DigitalCatalogButton" title="デジタルカタログを閲覧できます">デジタルカタログ</button>}
          </div>

          <div className="Progress-Body" ref={ref=>{this.ProgressBody=ref}}>

            <div className="Progress-List" ref={ref=>{this.ProgressList=ref}}>
              <div className="Progress-List-Header" onClick={this.handleClickSortHeader}>
                <span className="Progress-List-Header-Title">並べ替え</span>
                <select className="Progress-List-Header-Select" onChange={this.handleChangeSortSelect} value={this.state.sortType}>
                  <option value="hinmei">名前順</option>
                  <option value="coverStatus">表紙進捗順</option>
                  <option value="hontaiStatus">本文進捗順</option>
                  <option value="bunsyuStatus">文集進捗順</option>
                  <option value="delivery">発送進捗順</option>
                </select>
                <span className={"Progress-List-SortBtn Progress-List-Sort-DirectionBtn" + (this.state.sortDirection === 'desc' ? ' Progress-List-Sort-Current' : '')} data-direction="desc">▼</span>
                <span className={"Progress-List-SortBtn Progress-List-Sort-DirectionBtn" + (this.state.sortDirection === 'asc' ? ' Progress-List-Sort-Current' : '')} data-direction="asc">▲</span>
                <span className={"Progress-List-SortBtn Progress-List-Sort-TypeBtn" + (this.state.sortType === 'hinmei' ? ' Progress-List-Sort-Current' : '')} data-type="hinmei">名前順</span>
                <span className={"Progress-List-SortBtn Progress-List-Sort-TypeBtn" + (this.state.sortType === 'coverStatus' ? ' Progress-List-Sort-Current' : '')} data-type="coverStatus">表紙進捗順</span>
                <span className={"Progress-List-SortBtn Progress-List-Sort-TypeBtn" + (this.state.sortType === 'hontaiStatus' ? ' Progress-List-Sort-Current' : '')} data-type="hontaiStatus">本文進捗順</span>
                <span className={"Progress-List-SortBtn Progress-List-Sort-TypeBtn" + (this.state.sortType === 'bunsyuStatus' ? ' Progress-List-Sort-Current' : '')} data-type="bunsyuStatus">文集進捗順</span>
                <span className={"Progress-List-SortBtn Progress-List-Sort-TypeBtn" + (this.state.sortType === 'delivery' ? ' Progress-List-Sort-Current' : '')} data-type="delivery">発送進捗順</span>
              </div>
              <table>
                <tbody onClick={this.handleClickAlbum} ref={ref=>{this.ProgressTbody=ref}}>{
                  this.state.albums.map(alb=>{
                    return (
                      <tr key={alb.code} data-code={alb.code} className={this.state.selectedAlbum===alb.code?'selected':''}>
                        { !this.state.orderConfirm ? null
                         : <td className="orderConfirm" data-status={alb.orderConfirm}><FontAwesomeIcon icon={faCheckCircle} /></td>
                        }
                        <td className="hinmei">{alb.hinmei}</td>
                        <td className="customer_tanto">{alb.customer_tanto}</td>
                        <td className="cover" data-status={alb.coverStatus}><span className="statusLamp" title={this.getStatusText(alb.coverStatus)}>表紙</span></td>
                        <td className="hontai" data-status={alb.hontaiStatus}><span className="statusLamp" title={this.getStatusText(alb.hontaiStatus)}>本文</span></td>
                        <td className="bunsyu" data-status={alb.bunsyuStatus}><span className="statusLamp" title={this.getStatusText(alb.bunsyuStatus)}>文集</span></td>
                        <td className="delivery" data-status={(alb.delivery>0?'send':'yet')}><span className="statusLamp" title={this.getStatusText(alb.delivery>0?'send':'yet')}>発送</span></td>
                      </tr>
                    )
                  })
                }</tbody>
              </table>
            </div>

            <SplitBar left={this.ProgressList} right={this.ProgressAlbum} currentSelect={this.state.selectedAlbum} onClose={this.splitBarOnClose} ref={ref=>{this.splitBar=ref;}}></SplitBar>
            <Album ref={ref=>{this.ProgressAlbum=ref}}
              albumCode={this.state.selectedAlbum} showPDFAuthority={this.state.showPDFAuthority} orderConfirm={this.state.orderConfirm}
              koryoLimit={this.state.customerInfo?this.state.customerInfo.koryoLimit:null}
              updateOrderConfirmStatus={this.handleUpdateConfirmStatus} close={this.handleClose}>
            </Album>
          </div>

          {
            this.renderToolsRequestDialog()
          }
          {
            this.renderDigitalCatalogDialog()
          }
          {
            this.state.showLogoutDialog
            ? this.renderLogoutDialog()
            : null
          }

          {
            this.state.alert
            ? (<AlertDialog {...this.state.alert}>{this.state.alert.contents}</AlertDialog>)
            : null
          }
          
        </div>
      </LoadingOverlay>
    );
  }
}
export default Progress;